import { render } from "./captable.vue?vue&type=template&id=cd903930"
import script from "./captable.vue?vue&type=script&lang=ts"
export * from "./captable.vue?vue&type=script&lang=ts"

import "./captable.vue?vue&type=style&index=0&id=cd903930&lang=scss"
script.render = render

export default script